import type { Permission } from '~/enums'

export const hasAnyPermission = (
  granted: readonly Permission[],
  required: readonly Permission[]
): boolean => required.some((permission) => granted.includes(permission))
